var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('register-search-grid',{on:{"write-detail":_vm.writeDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }